goog.provide("shadow.js.shim.module$src$svg$wpp$files$add_document_svg$default");
shadow.js.shim.module$src$svg$wpp$files$add_document_svg$default = shadow.js.shim.module$src$svg$wpp$files$add_document_svg.default;
